import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Sparkle } from "./Decor";

export const OrderCTA = () => (
  <section className="px-4 py-20 sm:px-6" data-testid="order-cta-section">
    <div className="stitch-box relative mx-auto max-w-5xl overflow-hidden rounded-[2rem] bg-[#FF1F8E] px-8 py-14 text-white sm:px-14">
      <Sparkle className="absolute right-8 top-8" size={24} />
      <Sparkle className="absolute bottom-10 right-1/3" size={14} delay={1.2} />
      <p className="font-script text-4xl text-white/95">Have an idea?</p>
      <h2 className="mt-2 max-w-xl font-display text-3xl font-bold leading-tight sm:text-4xl">Let's stitch it into something you'll love.</h2>
      <p className="mt-4 max-w-lg text-white/85">Tell us what you're dreaming up and we'll get back to you with a quote.</p>
      <Link to="/order" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0E0B0D] px-7 py-4 font-semibold transition-transform duration-200 hover:-translate-y-0.5" data-testid="cta-start-order-btn">
        Start a Custom Order <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  </section>
);
